import { render, staticRenderFns } from "./waterSampleBox.vue?vue&type=template&id=5ff5904a"
import script from "./waterSampleBox.vue?vue&type=script&lang=js"
export * from "./waterSampleBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports